module.exports = "/static/assets/ccb22375c06ec83a1d74096b9722e150.png";